import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      waiverForms, // via redux state
      total, // calculated by parent, via redux state
      checkOut // via withMutation
    } = props

    const handleClickCheckout = event => {
      event.preventDefault()

      const checkOutInput = {
        cartTotal: total
      }

      // for GTM purchase payload
      const transactionType = 'new'

      const variables = {
        acceptWaiversInput: waiverForms,
        checkOutInput,
        transactionType
      }

      checkOut({
        variables
      })
    }

    return <WrappedComponent onClickCheckout={handleClickCheckout} {...props} />
  }
}

export default withEventHandlers
